import { useEffect } from "react";
import { useViolation } from "./ViolationContext";

export default function TabSwitchGuard() {
  const { addViolation } = useViolation();

  useEffect(() => {
    const handleBlur = () => {
      addViolation("TAB_SWITCH");
      alert("⚠️ Tab switching is not allowed during the test");
    };

    const handleVisibility = () => {
      if (document.hidden) {
        addViolation("TAB_HIDDEN");
        alert("⚠️ Do not switch tabs during the test");
      }
    };

    window.addEventListener("blur", handleBlur);
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      window.removeEventListener("blur", handleBlur);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [addViolation]);

  return null;
}
